import { SKILLS_ORDER } from 'constants/career-canvas';

import { getPositiveOrder } from './array';

export const sortSkillsAnswerOptionsCb = (first: string, second: string) =>
  getPositiveOrder(SKILLS_ORDER, first) -
  getPositiveOrder(SKILLS_ORDER, second);
